import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  defaultDateRange,
  membershipSalesSearchSchema,
} from '../modules/MembershipReport/constants';
import { MembershipReportPage } from '../modules/MembershipReport/MembershipReportPage';
import { devTestingCheck, membershipAdminCheck } from '../tools/permissionChecks';

export const Route = createFileRoute('/membership-report')({
  component: MembershipReportPage,
  validateSearch: membershipSalesSearchSchema,
  beforeLoad({ search }) {
    if (search.startDate && search.endDate) {
      return;
    }
    throw redirect({
      to: '/membership-report',
      replace: true,
      search: { ...search, ...defaultDateRange() },
    });
  },
  loader(ctx) {
    const user = ctx.context.authContext.user;
    if (!devTestingCheck(user) || !membershipAdminCheck(user)) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to access the Membership Report. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Membership report' }],
    };
  },
});
